export default {"src":"/_next/static/media/Instagram.1d2bd3b5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};